import React from "react";
import DoctorDetailPage from "./DoctorDetailPage";

const DrChayyaPalancontent = () => {
  return (
    <DoctorDetailPage
      name="Dr. Chayya Palan"
      specialization="Your Partner in Mind-Body Wellness"
      experience="11 Years specializing in Maternal Psychology"
      degrees="MSc (Clinical Psychology), Advance Diploma in Counselling Psychology"
      quote="I believe I am becoming a pregnancy crafter who cares for a mother's mind with the same seriousness as her body."
      sections={[
        {
          title: "My Philosophy on Pregnancy Care",
          body: "I practice with a holistic view. Pregnancy isn't just about scans and tests; it's about your sleep, your stress levels, your nutrition, and your emotional well-being. I am passionate about integrating modern medicine with timeless wellness practices like breathwork and mindfulness. My approach is to build a comprehensive wellness plan for you, not just a medical one.",
        },
        {
          title: "Why I Chose Myprega",
          body: "Myprega is the first platform I've seen that truly gets it. Their tech-enabled, continuous care model allows us to look at the whole picture of a mother's health, every single day. The brand's philosophy of treating the mother as a whole person, not a collection of symptoms, is the future of obstetrics.",
        },
        {
          title: "Beyond the Clinic",
          body: "I am a certified yoga instructor and practice every morning. I believe movement is medicine. On weekends, I love exploring local farmers' markets for fresh ingredients to experiment with new, healthy recipes. My favourite author is Thich Nhat Hanh.",
        },
      ]}
      favorites={[
        { icon: "📖", label: "Favourite Book", value: "Sapiens - A Brief History of Humankind" },
        { icon: "🎵", label: "Favourite Singer", value: "Lata Mangeshkar" },
        { icon: "🍽️", label: "Favourite Pastime", value: "Semi-classical music\nGardening" },
      ]}
    />
  );
};

export default DrChayyaPalancontent;
